import React from 'react';
import { MdClose } from 'react-icons/md';

import Box from '../../Box';
import Flex from '../../Flex';

function Option({
  isDragging,
  inBox,
  index,
  label,
  onCancel,
  ...props
}) {
  return (
    <Flex
      opacity={isDragging ? 0.5 : 1}
      cursor="move"
      px="1em"
      py="1em"
      my="0.5em"
      bg="variations.blue.0"
      alignItems="center"
      {...props}
    >
      {inBox && index !== undefined && (
        <Box p="0.25em" mr="0.5em" color="primary" fontWeight="bold">
          {index + 1}
        </Box>
      )}
      <Box flex={1}>{label}</Box>
      {onCancel && <Box onClick={onCancel}><MdClose /></Box>}
    </Flex>
  );
}

export default Option;
